import { render, staticRenderFns } from "./SupplierTractsDetail.vue?vue&type=template&id=54f3bdd0&"
import script from "./SupplierTractsDetail.vue?vue&type=script&lang=js&"
export * from "./SupplierTractsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports